import { render, staticRenderFns } from "./TemplateChoose.vue?vue&type=template&id=13b0ed4e"
import script from "./TemplateChoose.vue?vue&type=script&lang=jsx"
export * from "./TemplateChoose.vue?vue&type=script&lang=jsx"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports